import type { BrowserOptions } from '@sentry/nextjs';

/**
 * What the Sentry SDK may attach to events, shared by every `Sentry.init`.
 *
 * From v11, leaving `dataCollection` unset collects cookies, headers, request
 * and response bodies, GraphQL variables and stack-frame locals. Here that
 * would mean session tokens, chat messages, phone numbers and emails, so
 * everything personal is off. This keeps the v10 `sendDefaultPii: false`
 * behavior: errors, stack traces and URLs only. Pass user IDs explicitly with
 * `Sentry.setUser`.
 */
export const SENTRY_DATA_COLLECTION: NonNullable<
  BrowserOptions['dataCollection']
> = {
  userInfo: false,
  cookies: false,
  httpHeaders: false,
  httpBodies: [],
  urlQueryParams: true,
  graphQL: { document: true, variables: false },
  genAI: { inputs: false, outputs: false },
  databaseQueryData: false,
  queues: false,
  stackFrameVariables: false,
  frameContextLines: 7,
};
